import React from 'react'

export function AncientTemple({ className = '' }) {
  return (
    <svg
      viewBox="0 0 1200 600"
      className={`w-full h-full ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
    >
      <defs>
        <linearGradient id="templeSky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ff7e5f" />
          <stop offset="50%" stopColor="#feb47b" />
          <stop offset="100%" stopColor="#ffe259" />
        </linearGradient>
        <linearGradient id="stoneGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#e0e0e0" />
          <stop offset="100%" stopColor="#9e9e9e" />
        </linearGradient>
        <linearGradient id="darkStoneGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#9e9e9e" />
          <stop offset="100%" stopColor="#616161" />
        </linearGradient>
        <filter id="sunGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="20" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Background */}
      <rect width="1200" height="600" fill="url(#templeSky)" />

      {/* Giant Sun */}
      <circle cx="600" cy="300" r="150" fill="#ffffff" opacity="0.9" filter="url(#sunGlow)" />

      {/* Distant Temple Ruins */}
      <g fill="#d89a7a" opacity="0.6">
        <rect x="100" y="400" width="50" height="200" />
        <rect x="180" y="450" width="40" height="150" />
        <rect x="950" y="350" width="60" height="250" />
        <rect x="1050" y="420" width="50" height="180" />
        <path d="M80 400 L170 400 L125 350 Z" />
        <path d="M930 350 L1030 350 L980 280 Z" />
      </g>

      {/* Main Platform */}
      <g transform="translate(150, 450)">
        <path d="M50 0 L850 0 L900 50 L850 150 L50 150 L0 50 Z" fill="url(#stoneGrad)" />
        <rect x="100" y="0" width="700" height="20" fill="url(#darkStoneGrad)" />
        <rect x="150" y="20" width="600" height="20" fill="url(#stoneGrad)" />
        <rect x="50" y="-150" width="40" height="150" fill="url(#stoneGrad)" />
        <rect x="40" y="-160" width="60" height="10" fill="url(#darkStoneGrad)" />
        <rect x="810" y="-150" width="40" height="150" fill="url(#stoneGrad)" />
        <rect x="800" y="-160" width="60" height="10" fill="url(#darkStoneGrad)" />
        <path d="M50 -150 Q 70 -100 40 -50 T 60 0" stroke="#2e7d32" strokeWidth="4" fill="none" />
        <path d="M850 -150 Q 830 -100 860 -50 T 840 0" stroke="#2e7d32" strokeWidth="4" fill="none" />
        <path d="M300 0 Q 320 30 310 60" stroke="#2e7d32" strokeWidth="5" fill="none" />
        <path d="M600 0 Q 580 40 590 80" stroke="#2e7d32" strokeWidth="5" fill="none" />
      </g>

      {/* Left Floating Platform */}
      <g transform="translate(200, 250)">
        <rect x="0" y="0" width="200" height="30" rx="5" fill="url(#stoneGrad)" />
        <rect x="10" y="30" width="180" height="15" fill="url(#darkStoneGrad)" />
        <path d="M20 30 Q 10 50 25 70" stroke="#2e7d32" strokeWidth="3" fill="none" />
      </g>

      {/* Right Floating Platform */}
      <g transform="translate(800, 250)">
        <rect x="0" y="0" width="200" height="30" rx="5" fill="url(#stoneGrad)" />
        <rect x="10" y="30" width="180" height="15" fill="url(#darkStoneGrad)" />
        <path d="M180 30 Q 190 60 170 80" stroke="#2e7d32" strokeWidth="3" fill="none" />
      </g>

      {/* Top Center Floating Platform */}
      <g transform="translate(500, 120)">
        <rect x="0" y="0" width="200" height="30" rx="5" fill="url(#stoneGrad)" />
        <rect x="10" y="30" width="180" height="15" fill="url(#darkStoneGrad)" />
      </g>
    </svg>
  )
}
